import { WriteDirectionEnum } from '@inter-ikea-kompis/enums';
import { useServiceSettings } from '@app/contexts/serviceSettings';

const useIsRtl = () => {
  const { dexfSettings } = useServiceSettings();
  return dexfSettings?.localisation?.writeDirection === WriteDirectionEnum.rtl;
};

export default useIsRtl;
